import {planTypes} from "@/common/constants";
import { getPlanLogo } from '@/common/plan-logo-map';

export default {
  key: planTypes[planTypes.WORKSPACE_RESERVATION],
  data () {
    return {
      logo: getPlanLogo(planTypes.WORKSPACE_RESERVATION),
      title: this.$t('billing.workspace_reservation.title'),
      planType: planTypes.WORKSPACE_RESERVATION,
    }
  }
};
